import { icon } from "../config";
import { isDateValid } from "../shared/validators/validator";
import { formatUserTimestamp } from "../components/TaskSidebar/sidebar.common";

export const editorToolType = {
  TASK_SIDEBAR_TOOL: "taskSidebartools",
  TASK_POPUP_TOOL: "taskPopuptools",
  DOX_TOOL: "Dox",
};

export const editorEntity = {
  TASK_DESC: "Task Desc",
};

export const MODE_ARRAY = [
  { modeId: 2, mode: "All", icon: icon.KEYBOARD_HIDE, class: "green" },
  { modeId: 3, mode: "Smart Chips Only", icon: icon.KEYBOARD_LOCK, class: "yellow" },
  { modeId: 1, mode: "Read Only", icon: icon.KEYBOARD_LOCK_OFF, class: "red" },
];

export const MEDIA_ARRAY = [
  { icon: icon.INSERT_IMAGE_EDITOR, media: "Image" },
  { icon: icon.IFRAME, media: "Add External URL" },
  { icon: icon.PICTURE_AS_PDF, media: "Add PDF" },
];

export const defaultUserChip = (acknowledgeChip) => ({
  label: acknowledgeChip ? "Sender Name" : "Select User",
  Email: null,
});

export const editorToolsDimension = {
  rowHeight: 25,
  colWidth: 25,
};

export const editorToolsGap = {
  rows: 5,
  cols: 5,
};

export const cleanFormattingLabel = "Clean Formatting";

export const emailVariable = [
  {
    label: "Sender Name",
    name: "Sender Name",
    varId: "user",
    class: "user-chip",
  },
  {
    label: "Reference ID",
    name: "Reference Id",
    varId: "RefId",
  },
  {
    label: "Unique ID",
    name: "Unique Id",
    varId: "UId",
  },
];

export const workFlowEmailTaskKeys = ["AcknowledgeEmail", "TaskEmail", "AiEmail"];

export const VARIABLE_VALUES = {
  CURRENT_DATE: "Current Date",
};

export const WEBSOCKET_CONFIG = {
  MAX_RETRIES: 3,
  MAX_BACKOFF_TIME: 10000, // 10 seconds
  BASE_DELAY: 1000, // 1 second
  CONNECTION_STATUS: {
    CONNECTED: "connected",
    DISCONNECTED: "disconnected",
    CONNECTING: "connecting",
    ERROR: "error",
  },
  DOC_UPDATE_BATCH: {
    DEBOUNCE_MS: 1000,
    IMMEDIATE_FLUSH_MIN_BYTES: 4096,
  },
};

export const BOOKMARK_TOOL_CONSTANTS = {
  CLASS_NAME: "icon-bookmark",
}

export const BOOKMARK_NODE_TYPES = ["paragraph", "heading"];
const SAVED_VERSION = "Saved Version";
export const VERSION_TYPES = {
  "weekly" : {
    label: () => "Weekly",
    group: "Automatic Backups",
  },
  "hourly" : {
    label: () => "Hourly",
    group: "Automatic Backups",
  },
  "daily" : {
    label: () => "Daily",
    group: "Automatic Backups",
  },
  "user-manual" : {
    group: "Manually Created",
    label: (versionName) => `${versionName?.split(" | ")?.[0] || SAVED_VERSION}`,
  }
}

export const getVersionName = (label, timestamp) => {
  try {
    if(!isDateValid(timestamp)) {
      return label || SAVED_VERSION;
    }
    let date = new Date(timestamp);
    return formatUserTimestamp(label, date);
  }
  catch(error) {
    return label || SAVED_VERSION;
  }
}